import { Form } from "react-bootstrap";
import { DASH, formatHours, formatMoney } from "../builder/format";
import type { ChildGovernance } from "./childScope";

interface Props {
  governances: ChildGovernance[];
  currency: string;
}

// The change request project's governance, as calculated on its hours.
const ChildGovernanceTable = ({ governances, currency }: Props) => {
  if (governances.length === 0) return null;
  return (
    <>
      <Form.Text className="text-muted mb-2 d-block">
        Calculated on this change request&apos;s hours
      </Form.Text>
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Governance</th>
            <th>Calculated by</th>
            <th>Hours</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {governances.map((g) => (
            <tr key={g.id}>
              <td>{g.description}</td>
              <td>{g.calculatedBy}</td>
              <td>{formatHours(g.hours)}</td>
              <td>{g.revenue === null ? DASH : formatMoney(g.revenue, currency)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default ChildGovernanceTable;
